<template>
  <ModalBase :show-modal="showModal" :narrow="true" :overlay-scrollb="true" @close-modal="close">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ (isEdit) ? $gettext('EDIT'): $gettext('ADD') }}
        </template>
        <template v-slot:title>
          <span v-if="isEdit">{{projectDetails.name}}</span>
          <span v-if="!isEdit" v-translate>New project</span>
        </template>
        <template v-slot:buttons>
          <div class="modal-action-bar">
            <GekkoButton 
              v-if="isEdit" 
              @click="archiveProject()" 
              :text="archiveText" 
              :icon="archiveIcon" 
              class="text-info"
            />
            <GekkoButton 
              v-if="isEdit" 
              :text="$gettext('Delete project')" 
              icon="fa-solid fa-trash-can" 
              class="text-danger"
              v-gk-confirm="{
                title: $gettext('Delete project?'),
                message: $gettext('Are you sure you want to delete this project?'),
                options: {
                    variant: 'danger',
                    confirmText: $gettext('Delete')
                },
                callback: deleteProject
              }"
            />
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <AddEditProject ref="addeditproject" v-if="projectDetails && contactId" :projectDetails="projectDetails" :contactData="contactId" :projectData="projectId" @created="onProjectCreated" @updated="onProjectUpdated"></AddEditProject>
    </template>
    <template v-slot:actions>
      <GekkoButton 
        @click="$refs.addeditproject.saveForm()"
        :text="$gettext('Save')"
        icon="fa-solid fa-floppy-disk"
        type="submit"
        class="float-right position-relative"
        :loading="isWaitingForResponse"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import AddEditProject from "@/components/contacts/AddEditProject"
import GekkoButton from "@/components/GekkoButton";
import ProjectService from "@/store/services/project.service";
import { mapGetters } from 'vuex';

export default {
  name: "ProjectModal",
  props: {
    showModalOn: {
      type: Array,
      default: () => []
    },
    forceOpen: {
      type: Boolean,
      default: false
    },
    contactData: {
      type: Number,
      default: null
    },
    customerId: {
      type: Number,
      default: null
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  components: { ModalBase, TitleBar, AddEditProject, GekkoButton },
  watch: {
    forceOpen(val) {
      this.showModal = val;
    },
    contactData(val) {
      this.contactId = val
      this.initializeProjectDetails();
    },
    $route: {
      immediate: true,
      handler(to) {
        this.showModal = this.showModalOn.includes(to.name)||this.forceOpen;
        (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');

        if (this.$route.params['contactId']) {
          this.contactId = this.$route.params['contactId']
        } else if (this.customerId) {
          this.contactId = this.customerId
        }
        if (this.projectId) {
            this.getProjectDetails(this.projectId)
        } else {
          if (this.$route.params['projectId']) { // edit
            this.getProjectDetails(this.$route.params['projectId'])
          } else if (this.$route.params['contactId']) { // add
            this.initializeProjectDetails();
          }
        }

      }
    }
  },
  data() {
    return {
      contactId: null,
      showModal: false,
      projectDetails: null,
      defaultOpenerRoute: 'Contacts'
    }
  },
  created() {
    if (this.customerId) {
      this.contactId = this.customerId
    } else {
      this.contactId = this.contactData
    }
    this.initializeProjectDetails()
    window.addEventListener('keydown', this.closeEventListener);
  },
  destroyed () {
    window.removeEventListener('keydown', this.closeEventListener);
  },
  methods: {
    getProjectDetails (project_id) {
      ProjectService.retrieve(project_id).then((response) => {
        this.projectDetails = response.data
        this.contactId = this.projectDetails.company
      });
    },
    closeEventListener(event) {
      if (this.showModal && event.key === 'Escape') this.closeModal()
    },
    close(){
      this.$emit('cancel')
      this.closeModal()
    },
    onProjectCreated(val) {
      this.$emit('created', val)
      this.closeModal()
    },
    onProjectUpdated(val) {
      this.$emit('updated', val)
      this.closeModal()
    },
    onProjectDeleted() {
      this.$emit('deleted', this.projectId);
      this.closeModal()
    },
    closeModal () {
      if (this.forceOpen) {
        this.showModal = false
        this.$emit('cancel')
        document.body.classList.remove('modal-on')
      } else {
        if (this.$route.name !== this.defaultOpenerRoute) this.$router.push({name: this.defaultOpenerRoute})
      }
    },
    archiveProject() {
      let projectId

      if (this.projectId) {
        projectId = this.projectId;
      } else {
        projectId = this.$route.params['projectId'];
      }

      this.projectDetails.is_archived = !this.projectDetails.is_archived;

      ProjectService.update(projectId, this.projectDetails).then(() => {
        this.onProjectUpdated(this.projectDetails);
      });
    },
    deleteProject() {
      if (this.forceOpen) {
        this.onProjectDeleted()
      } else {
        this.$emit('deleted', this.$route.params['projectId']);
        this.$router.push({name: this.defaultOpenerRoute});
      }
    },
    initializeProjectDetails() {
      this.projectDetails = {
        company: null,
        name: "",
        contact_name: null,
        reference: "",
        description: "",
        hourly_rate: null,
        favorite: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      isWaitingForResponse: 'main/isWaitingForResponse'
    }),
    archiveText() {
      if (this.projectDetails.is_archived)
        return this.$gettext("Unarchive");
      else
        return  this.$gettext("Archive");
    },
    archiveIcon() {
      if (this.projectDetails.is_archived)
        return  "fa-solid fa-folder-open";
      else
        return "fa-solid fa-folder";
    },
    isEdit () {
      return this.$route.params['projectId'] || this.projectId
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
